import * as React from 'react'
import * as Recharts from 'recharts'
import './barChart.css'

class BarChart extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
    }
    render() {
        const {BarChart, Bar} = Recharts;
        const {barData} = this.props;
        return (
             <BarChart width={150} height={40} data={barData} >
                 <Bar dataKey="uv" fill="#f6a004"/>
             </BarChart>
        );
    }
}

export default BarChart



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/BarChart/index.tsx